import React, { useState, useEffect } from 'react';
import {Box, Button, Card, CardBody, CardFooter, CardHeader, Footer, Heading, Image, Text} from 'grommet';
import axios from 'axios';
import QRCode, {QRCodeCanvas} from 'qrcode.react';
import {getToken, getUserId} from "../utils/token";
import {ShareOption} from "grommet-icons";
import api from "../utils/api";
import ReactCardFlip from "react-card-flip";
import fidelityCard from "../assets/ottica-cerasi.png"

function CustomerDashboard() {
    const [customerInfo, setCustomerInfo] = useState({});
    const [storeOffers, setStoreOffers] = useState([]);
    const [stores, setStores] = useState([]);
    const [flipped, setFlipped] = useState(false);
    const [qrCodeHidden, setQrCodeHidden] = useState(true);
    /*
    useEffect(() => {
        let jwtToken = getToken();
        axios.get(process.env.REACT_APP_BASE_API_URL + 'api/users/' + getUserId(),
            {
                method: 'get',
                headers:{
                    'Authorization': `Bearer ${jwtToken}`,
                    'Accept': 'application/ld+json',
                }
            })
            .then(response => {
                setCustomerInfo(response.data);
                let info = response.data;
                //setStoreOffers(response.data.storeOffers);
                //setStores(response.data.stores);
            })
            .catch(error => {
                console.error(error);
            });
    }, []);

    */

    useEffect(() => {
        api.get(process.env.REACT_APP_BASE_API_URL + 'api/users/' + getUserId()).then((response) => {
            if (response) {
                setCustomerInfo(response.data);
                let info = response.data;
            }
        }).catch(error => {
            console.error(error);
        });
    }, []);


    const qrBox = {
        display: qrCodeHidden ? 'none' : '',
        transition: "opacity 0.5s ease-in;",
        animation: qrCodeHidden ? "disappear 1s ease" : "appear 1s ease",

        opacity: qrCodeHidden ? 0 : 1
    };

    const qrStyle ={
        border: 'dashed',
        borderRadius: '10px',
    }
    const points = undefined;


    function handleClick(e) {
        e.preventDefault();
        setFlipped(prevFlipped => !prevFlipped);
        setQrCodeHidden(prevqrCode => !prevqrCode)
    }

    return (

    <Box pad="medium">
            <Heading level={1}>Dashboard</Heading>
            <ReactCardFlip isFlipped={flipped} flipDirection="horizontal">
                <Card
                    background="light-1"
                    //border="dark"
                    onClick={handleClick}
                    height={"300px"}
                >
                    <CardBody>
                        <Image
                          fit="cover"
                          src={fidelityCard}
                          a11yTitle="Ottica Ceraci"
                        />
                    </CardBody>
                </Card>


                <Card
                    background="light-1"
                    //border="dark"
                    onClick={handleClick}
                    height={"300px"}
                >

                <CardHeader pad="medium">
                        <Text weight={"bold"} color={"brand"}>
                            Ciao {customerInfo.name} 👋
                        </Text>
                    </CardHeader>
                    <CardBody pad="medium" style={qrBox}>
                        <Box direction={"column"} pad={"small"} gap={"medium"} alignContent={"around"}>

                            {/*
                            <Box>
                                <Text>Nome: {customerInfo.name} {customerInfo.surname}</Text>
                                <Text>Email: {customerInfo.email}</Text>
                                <Text>Saldo punti: {customerInfo.fidelityCards?.[0] ? customerInfo.fidelityCards?.[0].points : 0} </Text>
                            </Box>
                            */}
                            <Box width="300px" align={"center"} animation={"fadeIn"} >
                                <QRCodeCanvas value={`${customerInfo.email}`} size={192} includeMargin={true} style={qrStyle}
                                        bgColor={"transparent"} />
                            </Box>

                        </Box>
                    </CardBody>
                    {/*<CardFooter pad={{horizontal: "small"}} background="light-3">
                        <Button icon={<ShareOption color="plain"/>} hoverIndicator/>
                    </CardFooter>*/}
                </Card>
            </ReactCardFlip>
            {/*
            <Box direction="row" gap="medium" align="center">
                <Box width="200px">
                    <QRCode value={`${customerInfo.email}`} size={192} includeMargin={true} />
                </Box>
                <Box>
                    <Text>Nome: {customerInfo.name} + {customerInfo.surname}</Text>
                    <Text>Email: {customerInfo.email}</Text>
                    <Text>Saldo punti: {customerInfo.fidelityCards ? customerInfo.fidelityCards[0].points : 0} </Text>
                </Box>
            </Box>
            */}
            {/*<Box margin={{ top: 'medium' }}>
                <Heading level={2}>Store Offers</Heading>
                {storeOffers.map(storeOffer => (
                    <Box key={storeOffer.id} background="light-2" pad="medium" margin={{ bottom: 'medium' }}>
                        <Text weight="bold">{storeOffer.title}</Text>
                        <Text>{storeOffer.description}</Text>
                    </Box>
                ))}
            </Box>
            <Box margin={{ top: 'medium' }}>
                <Heading level={2}>Stores</Heading>
                {stores.map(store => (
                    <Box key={store.id} background="light-2" pad="medium" margin={{ bottom: 'medium' }}>
                        <Text weight="bold">{store.name}</Text>
                        <Text>{store.address}</Text>
                    </Box>
                ))}
            </Box>*/}
        </Box>
    );
}

export default CustomerDashboard;
